import { FC, useState } from 'react'

import { RedRed60, SequenceMenu } from '@sequencehq/core-components'

import { ListPriceArchiveModal } from 'Products/modals'

export const ArchiveListPriceMenuItem: FC<{
  listPriceId: string
  onClose: () => void
  onSuccess: () => void
}> = ({ listPriceId, onClose, onSuccess }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <SequenceMenu.Item
        key="archive-list-price"
        uuid="archive"
        label="Archive"
        data-testid={`product.listPrices.${listPriceId}.archive`}
        style={{ color: RedRed60 }}
        onClick={() => setShowModal(true)}
      />
      {showModal && (
        <ListPriceArchiveModal
          listPriceId={listPriceId}
          onClose={onClose}
          onSuccess={onSuccess}
        />
      )}
    </>
  )
}
